import React, { Fragment } from "react";

function Loading() {
  return (
    <Fragment>
      <div className="row">
        <div className="col-md-12">
          <div className="preload d-inline-flex align-items-center mt-4 mb-4 py-3 px-3">
            <div>
              <svg
                style={{
                  margin: "auto",
                  display: "block",
                  shapeRendering: "auto",
                }}
                width="100px"
                height="100px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle cx="75" cy="50" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.9166666666666666s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.9166666666666666s"
                  ></animate>
                </circle>
                <circle cx="71.65063509461098" cy="62.5" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.8333333333333334s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.8333333333333334s"
                  ></animate>
                </circle>
                <circle cx="62.5" cy="71.65063509461096" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.75s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.75s"
                  ></animate>
                </circle>
                <circle cx="50" cy="75" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.6666666666666666s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.6666666666666666s"
                  ></animate>
                </circle>
                <circle
                  cx="37.50000000000001"
                  cy="71.65063509461098"
                  fill="#dcfff8"
                  r="5"
                >
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.5833333333333334s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.5833333333333334s"
                  ></animate>
                </circle>
                <circle cx="28.34936490538903" cy="62.5" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.5s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.5s"
                  ></animate>
                </circle>
                <circle cx="25" cy="50" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.4166666666666667s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.4166666666666667s"
                  ></animate>
                </circle>
                <circle
                  cx="28.34936490538903"
                  cy="37.50000000000001"
                  fill="#dcfff8"
                  r="5"
                >
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.3333333333333333s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.3333333333333333s"
                  ></animate>
                </circle>
                <circle
                  cx="37.499999999999986"
                  cy="28.349364905389038"
                  fill="#dcfff8"
                  r="5"
                >
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.25s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.25s"
                  ></animate>
                </circle>
                <circle cx="49.99999999999999" cy="25" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.16666666666666666s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.16666666666666666s"
                  ></animate>
                </circle>
                <circle cx="62.5" cy="28.349364905389034" fill="#dcfff8" r="5">
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="-0.08333333333333333s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="-0.08333333333333333s"
                  ></animate>
                </circle>
                <circle
                  cx="71.65063509461096"
                  cy="37.499999999999986"
                  fill="#dcfff8"
                  r="5"
                >
                  <animate
                    attributeName="r"
                    values="3;3;5;3;3"
                    dur="1s"
                    repeatCount="indefinite"
                    begin="0s"
                  ></animate>
                  <animate
                    attributeName="fill"
                    values="#dcfff8;#dcfff8;#18a79d;#dcfff8;#dcfff8"
                    repeatCount="indefinite"
                    dur="1s"
                    begin="0s"
                  ></animate>
                </circle>
              </svg>
            </div>
            <div>
              <h5>
                <b>
                  Os seus dados estão sendo processados. <br />
                  Por favor, aguarde.
                </b>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default Loading;
